import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { createSlideshow, updateSlideshow, fetchSlideshowDetail } from 'actions/Slideshow'
import FormSlideshowView from 'components/pages/slideshow/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchSlideshowDetail: bindActionCreators(fetchSlideshowDetail, dispatch),
  createSlideshow: bindActionCreators(createSlideshow, dispatch),
  updateSlideshow: bindActionCreators(updateSlideshow, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const { setData, setImgFile, setCurrentImg } = props

      try {
        const res = await props.fetchSlideshowDetail(id)
        setData(res)
        setImgFile(res.image)
        setCurrentImg(res.image)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleSubmit: props => (values) => {
      let payload

      props.setIsSubmit(true)

      if (props.imgFile === props.currentImg) {
        payload = {
          ...values,
        }
        delete payload.image
      } else {
        payload = {
          ...values,
          image: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updateSlideshow(props.match.params.id, payload)
          .then(() => {
            message.success('Slideshow has been updated')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/slideshow')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createSlideshow(payload)
          .then(() => {
            message.success('Slideshow has been created')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/slideshow')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { match, setIsEdit, getDetail } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Slideshow Form',
        activePage: 'slideshow',
        activeSubPage: 'slideshow',
      })
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormSlideshowView)
